import type {
  DropDownNoSelection,
  DropDownResult,
  DynamicFieldComponentProps,
  DynamicFieldDataProps,
} from '@myosh/odin-components';
import type { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { LookupTypeFieldProps } from '../../../@types/forms';
import { DropDownSelectionType } from '@myosh/odin-components';
import DisabledDropdownWrapper from '../custom-drop-downs/disabled-dropdown-wrapper.component';
import OdinDropDown from '../custom-drop-downs/odin-drop-down.component';
import useSupportComboboxFunctionalities from './use-support-combobox-functionalities';

export interface ComboboxMultiselectProps
  extends
    DynamicFieldComponentProps<DropDownResult | Array<DropDownResult> | DropDownNoSelection>,
    DynamicFieldDataProps,
    LookupTypeFieldProps {
  control: Control;
  formId: number;
  parentFieldId: string;
  parentLabel: string;
  isMultiselect?: boolean;
}

export default function ComboboxMultiselect({
  control,
  formId,
  lookupType,
  lookupKeyId,
  lookupHierarchyId,
  parentFieldId,
  parentLabel,
  readOnly,
  ...rest
}: ComboboxMultiselectProps) {
  const { t } = useTranslation();
  const { dropDownRef, getOptionsData, onSelectorVisible, showOverlay } = useSupportComboboxFunctionalities({
    control,
    formId,
    lookupType,
    lookupKeyId,
    lookupHierarchyId,
    parentFieldId,
    parentLabel,
    readOnly,
    ...rest,
    isMultiselect: true,
  });

  return (
    <DisabledDropdownWrapper
      visible={showOverlay && !readOnly}
      message={t('dependent-field-message', { fieldName: parentLabel })}
      {...rest}
    >
      <OdinDropDown
        {...rest}
        ref={dropDownRef}
        data={getOptionsData}
        allowDuplicateCall
        onSelectorVisible={onSelectorVisible}
        readOnly={readOnly}
        selectionType={DropDownSelectionType.Multiple}
        useChips={true}
        removeOnSelect={false}
        useCheckboxForMultiSelect={true}
        showValueInSelector={false}
      />
    </DisabledDropdownWrapper>
  );
}
